import React, { useState } from 'react'
import PropTypes from 'prop-types'
import styled from 'styled-components'
import {
  Collapse,
  ListItem,
  ListItemIcon,
  ListItemText,
} from '@material-ui/core'
import ExpandLess from '@material-ui/icons/ExpandLess'
import ExpandMore from '@material-ui/icons/ExpandMore'
import Icons from '../Icons'

const MenuListItem = styled(ListItem)`
  padding-left: ${props => props.theme.spacing(6)}px;
`
const MenuListItemIcon = styled(ListItemIcon)`
  min-width: 40px;
`
const MenuLabel = styled(ListItemText)`
  color: ${props => props.theme.palette.text.secondary};
  text-transform: uppercase;
  font-weight: bold;
`

const MenuLabelText = {
  fontWeight: `bold`,
}

const MenuCollapse = props => {
  const { children, title, icon, index, timeout } = props

  const [state, setState] = useState({
    open: true,
  })

  function handleClick() {
    setState(oldState => ({
      ...oldState,
      open: !state.open,
    }))
  }

  const ListCollapseIcon = () => {
    if (icon) {
      return (
        <MenuListItemIcon>
          <Icons
            icon={icon}
            style={{
              fontSize: 24,
              marginBottom: '6px',
            }}
          />
        </MenuListItemIcon>
      )
    }
    return null
  }
  const ExpandIcon = () => {
    if (!state.open) {
      return <ExpandLess color="action" />
    }
    return <ExpandMore color="action" />
  }

  return (
    <>
      <MenuListItem
        key={`${index}-${title}-button`}
        button
        onClick={handleClick}
      >
        <ListCollapseIcon />
        <MenuLabel
          primary={title}
          primaryTypographyProps={{ style: MenuLabelText }}
        />
        <ExpandIcon />
      </MenuListItem>
      <Collapse in={state.open} timeout={timeout} unmountOnExit>
        {children}
      </Collapse>
    </>
  )
}

MenuCollapse.propTypes = {
  children: PropTypes.node,
  title: PropTypes.string,
  index: PropTypes.any,
  icon: PropTypes.any,
  timeout: PropTypes.any,
}

export default MenuCollapse
